import { setBuyerPermissions } from './actions';
import { getBuyerPermissions } from '@/services/buyer-dashboard';
import { Dispatch } from 'redux';
import { IState } from '@/state/IState';
import { Profile } from '@/types';

export const loadBuyerPermissions = (activeProfile?: Profile | null) => {
    return async function (dispatch: Dispatch, getState: () => IState): Promise<any> {
        if (!activeProfile) activeProfile = getState().global.activeProfile;

        if (activeProfile) {
            const data = await getBuyerPermissions(activeProfile.id);
            return dispatch(setBuyerPermissions(data));
        }
    };
};
